var path = 'src/app/patients/results/results.html';
var html = "<h1 class=page-header>Lab Results, Observations</h1> <div results-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/results/results.html
 ** module id = 584
 ** module chunks = 0
 **/